import { queryClient } from '../../lib/queryClient';
import { supabase } from '../../lib/supabase';
import { clearCachedStatus } from '../../shared/auth/account-cache';
import { clearSelectedBatches } from '../../shared/lib/selected-batch-store';
import { clearWorkViews } from '../../shared/lib/work-view-store';

/**
 * The one way to sign out.
 *
 * Clearing the React Query cache alone is not enough: the account status, the
 * remembered attendance batch and the remembered work-queue view are also
 * seeded from localStorage, so without clearing all three the next person to
 * sign in on a shared device would render the previous user's chrome for a
 * round-trip, reopen their batch and land on their queue.
 */
export async function signOutAndReset(scope?: 'global'): Promise<void> {
  // Default stays local — every existing caller means "sign out of this
  // browser". 'global' is the account screen's "sign out everywhere", which
  // revokes the refresh tokens held by every other device as well.
  await supabase.auth.signOut(scope === 'global' ? { scope: 'global' } : undefined);
  clearCachedStatus();
  clearSelectedBatches();
  clearWorkViews();
  queryClient.clear();
}
